export const APP = 'APP'
export const PLUGIN = 'PLUGIN'